<div class="payment-summary-section">
  <div class="common-tab-with-buttons">
    <div class="inner-action-section inner-full-action">
      <div class="row align-items-center">
        <div class="col-12 col-md-12 col-lg-6">
          <h5 *ngIf="selectedFacility.length > 0 && !isCallTimeReport">
            <a href="javascript:;" class="h-title" (click)="facilityOpen()">
              <b>{{selectedFacility[0]?.facilityName}}</b>
              <span *ngIf="selectedFacility.length > 1">
                <b>({{selectedFacility?.length}})</b></span></a>
          </h5>
          <h5>{{reportName}} between {{this.range.start | localDate }} to {{this.range.end | localDate }}</h5>
        </div>
        <div class="col-12 col-md-12 col-lg-6">
          <div class="top-action-btns">
            <ul>
              <li>
                <a (click)="clearFilter()" class="btn btn-primary btn-sm">
                  <span class="custom-icons icon-rotate m-r"></span>Clear</a>
              </li>
              <li>
                <a href="javascript:;" class="btn btn-primary btn-sm" (click)="filterOpen()">
                  <span class="custom-icons icon-filter m-r"></span> Filter</a>
              </li>
              <li *ngIf="(isDailyProductionReport && isDailyProductionReportExportAllowed) || 
                         (isQualityReport && isQualityReportExportAllowed) || 
                         (isCallTimeReport && isCallTimeReportExportAllowed) || 
                         (isTATReport && isTATReportExportAllowed) || 
                         (isSpecialistBreakReport && isSpecialistBreakReportExportAllowed) || 
                         (isVobVolumeReport && isVobVolumeReportAllowed) ||
                         (isReAssignReport && isReAssignReportAllowed) || 
                         (isMissingInformationReport && isMissingInformationReportAllowed) || 
                         (isSpecialistPerformanceReport && isSpecialistPerformanceReportAllowed) || 
                         (isFacilityPayerReport && isFacilityPayerReportAllowed)">
                <div class="dropdown">
                  <a href="javascript:;" class="btn btn-primary btn-sm dropdown-toggle" id="dropdownExport"
                    data-bs-toggle="dropdown" aria-expanded="false">Export</a>
                  <ul class="dropdown-menu dropdown-top-position" aria-labelledby="dropdownExport">
                    <li>
                      <a class="dropdown-item" href="javascript:;" (click)="exportToExcel()">
                        <span class="custom-icons icon-excel m-r"></span>Excel</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="javascript:;" (click)="exportToPdf()">
                        <span class="custom-icons icon-pdf m-r"></span>PDF</a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="common-border table-responsive only-pager-grid">
      <!-- Daily Production Report -->
      <kendo-grid *ngIf="isDailyProductionReport" #dailyProductionReportGrid
        [data]="_commonPageService.groupPaginationListDataCommon" filterable="menu" [sortable]="true"
        [sort]="_commonPageService.commonState.sort" (sortChange)="sortChangeVOBReport($event)" [pageable]="true"
        [pageSize]="_commonPageService.commonState.take" [skip]="_commonPageService.commonState.skip"
        (pageChange)="pageChangeVOBReport($event)" [filter]="_commonPageService.commonState.filter"
        (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column [headerStyle]="{ justifyContent: 'center' }" field="specialistName" title="Specialist Name"
          class="text-center" [filterable]="true" [width]="100">
        </kendo-grid-column>
        <kendo-grid-column [headerStyle]="{ justifyContent: 'center' }" field="role" title="Role" class="text-center"
          [filterable]="true" [width]="100"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{ justifyContent: 'center' }" field="noOfRequestReceived" class="text-center"
          title="No. Of Request Received" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{ justifyContent: 'center' }" field="noOfRequestCompleted" class="text-center"
          title="No. Of Request Completed" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{ justifyContent: 'center' }" field="avgTime" class="text-center"
          title="Avg Time" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="Daily Production Report.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Daily Production Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="Daily Production Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- Quality Report -->
      <kendo-grid *ngIf="isQualityReport" #qualityReportGrid [data]="_commonPageService.groupPaginationListDataCommon"
        filterable="menu" [sortable]="true" [sort]="_commonPageService.commonState.sort"
        (sortChange)="sortChangeVOBReport($event)" [pageable]="true" [pageSize]="_commonPageService.commonState.take"
        [skip]="_commonPageService.commonState.skip" (pageChange)="pageChangeVOBReport($event)"
        [filter]="_commonPageService.commonState.filter" (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="vobId" class="text-center" title="VOB ID" [width]="80"
          [filterable]="false"></kendo-grid-column>
        <kendo-grid-column field="facilityName" title="Facility" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="patientName" title="Patient Name" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column field="receivedDate" title="Receipt Date" [filterable]="true" filter="date" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{dataItem.receivedDate | localDate}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="specialistName" title="Specialist" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column field="noOfErrors" class="text-center" title="Number of Errors" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column field="accuracy" class="text-center" title="Accuracy %" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column title="Change Log" [filterable]="false" [sortable]="false" [width]="100"
          [headerClass]="{'text-center': true}">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <ul class="grid-action-icon" *ngIf="dataItem.parentHistoryId > 0">
              <li>
                <a href="javascript:;"
                  (click)="showVobDetailedHistoryByVobId(dataItem.vobId,dataItem.requestId,dataItem.parentHistoryId);">
                  <div kendoTooltip class="grid-tooltip">
                    <span class="custom-icons icon-eye" [title]="'Detailed Info'"></span>
                  </div>
                </a>
              </li>
            </ul>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="Quality Report.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Quality Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
          <kendo-grid-column field="vobId" class="text-center" title="VOB ID" [width]="80"
            [filterable]="false"></kendo-grid-column>
          <kendo-grid-column field="facilityName" title="Facility" [filterable]="true"
            [width]="120"></kendo-grid-column>
          <kendo-grid-column field="patientName" title="Patient Name" [filterable]="true"
            [width]="120"></kendo-grid-column>
          <kendo-grid-column field="receivedDate" title="Receipt Date" [filterable]="true" filter="date" [width]="120">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>{{dataItem.receivedDate | localDate}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="specialistName" title="Specialist" [filterable]="true"
            [width]="120"></kendo-grid-column>
          <kendo-grid-column field="noOfErrors" class="text-center" title="Number of Errors" [filterable]="true"
            [width]="120"></kendo-grid-column>
          <kendo-grid-column field="accuracy" class="text-center" title="Accuracy %" [filterable]="true"
            [width]="120"></kendo-grid-column>
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="Quality Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- Call Metrics Report -->
      <kendo-grid *ngIf="isCallTimeReport" #callTimeReportGrid [data]="_commonPageService.groupPaginationListDataCommon"
        filterable="menu" [sortable]="true" [sort]="_commonPageService.commonState.sort"
        (sortChange)="sortChangeVOBReport($event)" [pageable]="true" [pageSize]="_commonPageService.commonState.take"
        [skip]="_commonPageService.commonState.skip" (pageChange)="pageChangeVOBReport($event)"
        [filter]="_commonPageService.commonState.filter" (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="vobId" class="text-center" title="#" [width]="50" [filterable]="false"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="specialistName" title="Specialist Name" [filterable]="true" [width]="150"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="payerName" title="Payer Name" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="facilityName" title="Facility Name" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="numberOfCalls" title="Number Of Calls" [filterable]="true" [width]="100"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="holdRates" title="Hold" [filterable]="true" [width]="100"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="successRates" title="Success Rates" [filterable]="true" [width]="100"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="totalDuration" title="Total Duration" [filterable]="true" [width]="100"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="Call Metrics Report.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Call Metrics Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="Call Metrics Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- TAT Report -->
      <kendo-grid *ngIf="isTATReport" #tatReportGrid [data]="_commonPageService.groupPaginationListDataCommon"
        filterable="menu" [sortable]="true" [sort]="_commonPageService.commonState.sort"
        (sortChange)="sortChangeVOBReport($event)" [pageable]="true" [pageSize]="_commonPageService.commonState.take"
        [skip]="_commonPageService.commonState.skip" (pageChange)="pageChangeVOBReport($event)"
        [filter]="_commonPageService.commonState.filter" (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="vobId" class="text-center" title="VOB" [width]="80"
          [filterable]="false"></kendo-grid-column>
        <kendo-grid-column field="facilityName" title="Facility" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="payerName" title="Payer" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="specialistName" title="Specialist" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column field="patientName" title="Patient Name" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column field="receivedDate" title="Received On" [filterable]="true" filter="date" [width]="90">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{dataItem.receivedDate | localDate}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="completedDate" title="Completed On" [filterable]="true" filter="date" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{dataItem.completedDate | localDate}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="reasonForMissing" title="Missing Reason" [filterable]="true"
          [width]="200"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="TAT Report.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>TAT Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="TAT Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- Specialist Break Report -->
      <kendo-grid *ngIf="isSpecialistBreakReport" #specialistBreakReportGrid
        [data]="_commonPageService.groupPaginationListDataCommon" filterable="menu" [sortable]="true"
        [sort]="_commonPageService.commonState.sort" (sortChange)="sortChangeVOBReport($event)" [pageable]="true"
        [pageSize]="_commonPageService.commonState.take" [skip]="_commonPageService.commonState.skip"
        (pageChange)="pageChangeVOBReport($event)" [filter]="_commonPageService.commonState.filter"
        (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="breakDate" title="Date" [filterable]="true" filter="date" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{dataItem.breakDate | localDate}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="specialistName" title="Specialist Name" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column field="specAvailable" title="Availability" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-column field="startTime" title="Start Time" [filterable]="true" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{ dataItem.startTime | localTimeSecond }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="endTime" title="End Time" [filterable]="true" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{ dataItem.endTime | localTimeSecond }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="duration" title="Duration(Mins)" [filterable]="true"
          [width]="120"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="Specialist Break Report.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Specialist Break Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="Specialist Break Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- VOB Volumne Report -->
      <kendo-grid *ngIf="isVobVolumeReport" #vobVolumeReportGrid
        [data]="_commonPageService.groupPaginationListDataCommon" filterable="menu" [sortable]="true"
        [sort]="_commonPageService.commonState.sort" (sortChange)="sortChangeVOBReport($event)" [pageable]="true"
        [pageSize]="_commonPageService.commonState.take" [skip]="_commonPageService.commonState.skip"
        (pageChange)="pageChangeVOBReport($event)" [filter]="_commonPageService.commonState.filter"
        (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="requestId" title="Request Id" [filterable]="true" [width]="70"></kendo-grid-column>
        <kendo-grid-column field="requestDate" title="Request Date" [filterable]="true" filter="date" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{dataItem.requestDate | localDate}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="facilityName" title="Facility" [filterable]="true" [width]="170"></kendo-grid-column>
        <kendo-grid-column field="carrierName" title="Payer" [filterable]="true" [width]="170"></kendo-grid-column>
        <kendo-grid-column field="requestStatus" title="Status" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="VobVolumeReport.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Vob Volume Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="VobVolumeReport.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- ReAssign/Rework Report -->
      <kendo-grid *ngIf="isReAssignReport" #reAssignReportGrid [data]="_commonPageService.groupPaginationListDataCommon"
        filterable="menu" [sortable]="true" [sort]="_commonPageService.commonState.sort"
        (sortChange)="sortChangeVOBReport($event)" [pageable]="true" [pageSize]="_commonPageService.commonState.take"
        [skip]="_commonPageService.commonState.skip" (pageChange)="pageChangeVOBReport($event)"
        [filter]="_commonPageService.commonState.filter" (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="historyId" title="#" [filterable]="true" [width]="50"></kendo-grid-column>
        <kendo-grid-column field="requestDate" title="Request Date" [filterable]="true" filter="date" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{dataItem.requestDate | localDate}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="facilityName" title="Facility Name" [filterable]="true"
          [width]="170"></kendo-grid-column>
        <kendo-grid-column field="specialistName" title="Specialist Name" [filterable]="true"
          [width]="170"></kendo-grid-column>
        <kendo-grid-column field="qaName" title="QA By" [filterable]="true" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="reAssignReason" title="Reason" [filterable]="true" [width]="200"></kendo-grid-column>
        <kendo-grid-column field="vobCount" title="# VOB" [filterable]="true" [width]="70"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="VobReAssignReport.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Vob Volume Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="VobReAssignReport.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- Missing Information Report -->
      <kendo-grid *ngIf="isMissingInformationReport" #missingInformationReportGrid
        [data]="_commonPageService.groupPaginationListDataCommon" filterable="menu" [sortable]="true"
        [sort]="_commonPageService.commonState.sort" (sortChange)="sortChangeVOBReport($event)" [pageable]="true"
        [pageSize]="_commonPageService.commonState.take" [skip]="_commonPageService.commonState.skip"
        (pageChange)="pageChangeVOBReport($event)" [filter]="_commonPageService.commonState.filter"
        (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="vobId" title="#" [width]="50" [headerStyle]="{ justifyContent: 'center' }"
          [filterable]="false" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="facilityName" title="Facility" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="specialistName" title="Specialist Name" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="averageDelayed" title="Average Delayed" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="reason" title="Delayed/Missing Reason" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="Missing Information Report.pdf" [allPages]="true" paperSize="A4"
          [repeatHeaders]="true" [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Missing Information Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="Missing Information Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- Facility Payer Report -->
      <kendo-grid *ngIf="isFacilityPayerReport" #facilityPayerReportGrid
        [data]="_commonPageService.groupPaginationListDataCommon" filterable="menu" [sortable]="true"
        [sort]="_commonPageService.commonState.sort" (sortChange)="sortChangeVOBReport($event)" [pageable]="true"
        [pageSize]="_commonPageService.commonState.take" [skip]="_commonPageService.commonState.skip"
        (pageChange)="pageChangeVOBReport($event)" [filter]="_commonPageService.commonState.filter"
        (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column *ngIf="selectedFacilityPayerId === 1" field="facilityName" title="Facility"
          [filterable]="true" [width]="120" [headerStyle]="{ justifyContent: 'center' }"
          class="text-center"></kendo-grid-column>
        <kendo-grid-column *ngIf="selectedFacilityPayerId === 2" field="payerName" title="Payer" [filterable]="true"
          [width]="120" [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="totalVob" title="Number of VOBs" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="totalCompletedVob" title="Number of VOBs Processed" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="totalTime" title="TAT" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="accuracy" title="Quality Scores" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="commonIssue" title="Common Issues" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="Facility Payer Report.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
          [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Facility Payer Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="Facility Payer Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>

      <!-- Specialist Performance Report -->
      <kendo-grid *ngIf="isSpecialistPerformanceReport" #specialistPerformanceReportGrid
        [data]="_commonPageService.groupPaginationListDataCommon" filterable="menu" [sortable]="true"
        [sort]="_commonPageService.commonState.sort" (sortChange)="sortChangeVOBReport($event)" [pageable]="true"
        [pageSize]="_commonPageService.commonState.take" [skip]="_commonPageService.commonState.skip"
        (pageChange)="pageChangeVOBReport($event)" [filter]="_commonPageService.commonState.filter"
        (filterChange)="filterChangeVOBReport($event)">
        <kendo-grid-column field="specialistName" title="Specialist Name" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="totalVob" title="Number of VOBs" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="totalCompletedVob" title="Number of VOBs Processed" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="totalTime" title="TAT" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="accuracy" title="Quality Scores" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-column field="breakTimings" title="Break Timings" [filterable]="true" [width]="120"
          [headerStyle]="{ justifyContent: 'center' }" class="text-center"></kendo-grid-column>
        <kendo-grid-messages [pagerItems]="'List'" [pagerOf]="'of'"></kendo-grid-messages>
        <kendo-grid-pdf fileName="Specialist Performance Report.pdf" [allPages]="true" paperSize="A4"
          [repeatHeaders]="true" [landscape]="true" [scale]="0.5">
          <!----custom div-->
          <kendo-grid-pdf-margin top="2.5cm" left="0.5cm" right="0.5cm" bottom="2.5cm">
          </kendo-grid-pdf-margin>
          <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="page-template">
              <div class="header" style="border-bottom: none;" [ngStyle]="{ display: pageNum <= 1 ? 'block' : 'none' }">
                <div class="address">
                  <div class="for" style="text-align: center; margin-top: 2%;">
                    <h3>Facility Payer Report</h3>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div style="float: right">
                  Page {{ pageNum }} of {{ totalPages }}
                </div>
              </div>
            </div>
          </ng-template>
          <!----custom div-->
        </kendo-grid-pdf>
        <kendo-grid-excel fileName="Specialist Performance Report.xlsx">
        </kendo-grid-excel>
      </kendo-grid>
    </div>
  </div>
</div>

<!-- Filter Popup Start -->
<kendo-dialog title="Filter Options" *ngIf="filterPopup" (close)="filterClose()" class="kendo-modal modal-md">
  <div class="common-popup-space">
    <div class="row">
      <div class="col-12 col-md-12" *ngIf="isFacilityPayerReport">
        <div class="form-group">
          <label class="form-label">Select Facility/Payer</label>
          <kendo-dropdownlist [data]="facilityPayerList" [textField]="'text'" [valueField]="'value'"
            [(ngModel)]="selectedFacilityPayerId" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </div>
      </div>
      <div
        *ngIf="!isSpecialistBreakReport && !isCallTimeReport && !isSpecialistPerformanceReport && (!isFacilityPayerReport || (selectedFacilityPayerId === 1 || selectedFacilityPayerId === 0))"
        class="col-12 col-md-12">
        <div class="form-group"
          *ngIf="this.coreHelperService.getLoggedInUserDetail().isMultipleFacility == 1 || this.coreHelperService.getLoggedInUserDomain() == 0">
          <label class="form-label">Select Facility</label>
          <kendo-multiselect [data]="selectFacilityList" [kendoDropDownFilter]="_reportService.filterSettings"
            [(ngModel)]="selectedFacility" [textField]="'facilityName'" [valueField]="'facilityId'"
            (valueChange)="onValueChangeFacility()" [autoClose]="false" class="multiselect-dropdown-height"
            [ngClass]="{'is-invalid': isSelected && selectedFacility?.length == 0}">
            <ng-template kendoMultiSelectHeaderTemplate>
              <span style="margin-left:14px">
                <input type="checkbox" id="chk" kendoCheckBox [checked]="isCheckedFacility"
                  [indeterminate]="isIndetFacility" (click)="onClickFacility()" />
                <kendo-label for="chk">&nbsp;&nbsp;&nbsp;{{ toggleAllTextFacility }}</kendo-label>
              </span>
            </ng-template>

            <ng-template kendoMultiSelectItemTemplate let-dataItem>
              <span>
                <kendo-label for="chk-{{ dataItem.facilityId }}">
                  <input type="checkbox" id="chk-{{ dataItem.facilityId }}" kendoCheckBox
                    [checked]="isFacilityItemSelected(dataItem)" />
                </kendo-label>
              </span>
              <span>{{ dataItem.facilityName }}</span>
            </ng-template>
          </kendo-multiselect>
          <div *ngIf="isSelected && selectedFacility?.length == 0" class="invalid-feedback">
            Please select facility
          </div>
        </div>
      </div>
      <div *ngIf="isFacilityPayerReport && selectedFacilityPayerId === 2" class="col-12 col-md-12">
        <div class="form-group">
          <label class="form-label">Select Payer</label>
          <kendo-multiselect [data]="selectPayerList" [kendoDropDownFilter]="_reportService.filterSettings"
            [(ngModel)]="selectedPayer" [textField]="'text'" [valueField]="'value'" (valueChange)="onValueChangePayer()"
            [autoClose]="false" class="multiselect-dropdown-height"
            [ngClass]="{'is-invalid': isSelected && selectedPayer?.length == 0}">
            <ng-template kendoMultiSelectHeaderTemplate>
              <span style="margin-left:14px">
                <input type="checkbox" id="chk" kendoCheckBox [checked]="isCheckedPayer" [indeterminate]="isIndetPayer"
                  (click)="onClickPayer()" />
                <kendo-label for="chk">&nbsp;&nbsp;&nbsp;{{ toggleAllTextPayer }}</kendo-label>
              </span>
            </ng-template>

            <ng-template kendoMultiSelectItemTemplate let-dataItem>
              <span>
                <kendo-label for="chk-{{ dataItem.value }}">
                  <input type="checkbox" id="chk-{{ dataItem.value }}" kendoCheckBox
                    [checked]="isPayerItemSelected(dataItem)" />
                </kendo-label>
              </span>
              <span>{{ dataItem.text }}</span>
            </ng-template>
          </kendo-multiselect>
          <div *ngIf="isSelected && selectedPayer?.length == 0" class="invalid-feedback">
            Please select payer
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12" *ngIf="!isCallTimeReport && !isFacilityPayerReport">
        <div class="form-group"
          *ngIf="this.coreHelperService.getLoggedInUserDetail().isMultipleFacility == 1 || this.coreHelperService.getLoggedInUserDomain() == 0">
          <label class="form-label">Select Specialist</label>
          <kendo-multiselect [data]="vobSpecialistList" [kendoDropDownFilter]="_reportService.filterSettings"
            [(ngModel)]="selectedVobSpecialist" [textField]="'userName'" [valueField]="'userId'"
            (valueChange)="onValueChangeSpecialist()" [autoClose]="false" class="multiselect-dropdown-height"
            [ngClass]="{'is-invalid': isSelected && selectedVobSpecialist?.length == 0}">
            <ng-template kendoMultiSelectHeaderTemplate>
              <span style="margin-left:14px">
                <input type="checkbox" id="chk" kendoCheckBox [checked]="isCheckedSpecialist"
                  [indeterminate]="isIndetSpecialist" (click)="onClickSpecialist()" />
                <kendo-label for="chk">&nbsp;&nbsp;&nbsp;{{ toggleAllTextSpecialist }}</kendo-label>
              </span>
            </ng-template>

            <ng-template kendoMultiSelectItemTemplate let-dataItem>
              <span>
                <kendo-label for="chk-{{ dataItem.userId }}">
                  <input type="checkbox" id="chk-{{ dataItem.userId }}" kendoCheckBox
                    [checked]="isSpecialistItemSelected(dataItem)" />
                </kendo-label>
              </span>
              <span>{{ dataItem.userName }}</span>
            </ng-template>
          </kendo-multiselect>
          <div *ngIf="isSelected && selectedVobSpecialist?.length == 0" class="invalid-feedback">
            Please select specialist
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12">
        <div class="form-group">
          <label class="form-label">Select</label>
          <kendo-dropdownlist [data]="filterlistItems" [(ngModel)]="selectedMonthss"
            (selectionChange)="getDateCalculation($event)">
          </kendo-dropdownlist>
        </div>
      </div>
      <div class="col-12 col-md-12" *ngIf="showCalender">
        <div class="form-group mb-0">
          <label class="form-label">Select Range</label>
          <kendo-daterange>
            <div class="date-range-box">
              <kendo-dateinput kendoDateRangeStartInput [(ngModel)]="range.start" [ngModelOptions]="{standalone: true}"
                [(value)]="range.start" [value]="dateValue"></kendo-dateinput>
              <span class="dash-range">-</span>
              <kendo-dateinput kendoDateRangeEndInput [(ngModel)]="range.end" [ngModelOptions]="{standalone: true}"
                [(value)]="range.end" [value]="dateValue"></kendo-dateinput>
            </div>
            <kendo-daterange-popup>
              <ng-template kendoDateRangePopupTemplate>
                <kendo-multiviewcalendar kendoDateRangeSelection [disabledDates]="_reportService.disabledDates">
                </kendo-multiviewcalendar>
              </ng-template>
            </kendo-daterange-popup>
          </kendo-daterange>
        </div>
      </div>
    </div>

  </div>
  <kendo-dialog-actions class="d-block text-end">
    <button kendoButton type="button" (click)="runReport()" class="btn btn-primary btn-md">Run</button>
    <button kendoButton (click)="filterClose()" class="btn btn-cancel btn-md">Cancel</button>
  </kendo-dialog-actions>
</kendo-dialog>
<!-- Filter Popup End -->

<!-- Title Facility Popup start -->
<kendo-dialog title="Facility List" *ngIf="facility" (close)="facilityClose()" class="kendo-modal modal-md">
  <div class="common-popup-space">
    <div class="row">
      <div class="col-12 col-md-12">
        <div class="form-group">
          <ul class="selected-facility-name">
            <li *ngFor="let item of selectedFacility">
              <span>{{item.facilityName}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <kendo-dialog-actions class="d-block text-end">
    <button kendoButton (click)="facilityClose()" class="btn btn-cancel btn-md">Cancel</button>
  </kendo-dialog-actions>
</kendo-dialog>
<!-- Title Facility Popup end -->
<kendo-dialog title="VOB Update History" *ngIf="showVobDetailHistory" (close)="showVobDetailHistory=false"
  class="kendo-modal modal-1180">
  <div class="common-border table-responsive">
    <kendo-grid [data]="detailedHistoryList" [sortable]="false" [pageable]="false" filterable="menu">
      <kendo-grid-column field="historyId" title="Id" [filterable]="false" [width]="50">
      </kendo-grid-column>
      <kendo-grid-column field="fieldId" title="Field Changed" [filterable]="false" [width]="210">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div>
            <span>{{dataItem.fieldId | camelCaseToSpaces}}</span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="oldValue" title="Old Change" [filterable]="false" [width]="180">
      </kendo-grid-column>
      <kendo-grid-column field="newValue" title="New Change" [filterable]="false" [width]="180">
      </kendo-grid-column>
      <kendo-grid-column field="byUserName" title="By User" [filterable]="false" [width]="180">
      </kendo-grid-column>
      <kendo-grid-column field="createdDate" title="Date" [filterable]="false" [width]="180" filter="date"
        format="{0:dd/MM/yyyy}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{dataItem.createdDate | localDateTime}}</span>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
  <kendo-dialog-actions class="d-block text-end">
    <button kendoButton (click)="showVobDetailHistory=false" class="btn btn-cancel btn-md">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>